var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59,20H29c-0.6,0-1,0.4-1,1v38c0,0.6,0.4,1,1,1h30c0.6,0,1-0.4,1-1V21C60,20.4,59.6,20,59,20z M58,22v6H30       c0-0.6,0-1.6,0-2h12v-2H30c0-0.2,0-2,0-2H58z M30,58c0,0,0-18.3,0-28h28v28H30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 32,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 32,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 32,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 37,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 37,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 37,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 41,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 41,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 41,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 41,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 45,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 45,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 45,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 49,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 49,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 49,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 49,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 53,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 53,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 53,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 53,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,14h11c0.6,0,1-0.4,1-1V2h34v14h2V1c0-0.6-0.4-1-1-1H13l0,0c-0.1,0-0.2,0-0.3,0.1h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2l-12,12       c-0.1,0.1-0.1,0.2-0.2,0.3v0.1C0.1,12.8,0,12.9,0,13l0,0v11h2C2,24,2,15.1,2,14z M12,12H3.4l4.3-4.3L12,3.4L12,12L12,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,43H14v-4v-5v-5c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v5v5v5v5v5v5c0,0.6,0.4,1,1,1h12h12c0.6,0,1-0.4,1-1v-5v-5v-5       C26,43.4,25.6,43,25,43z M2,45h10v3H2V45z M12,43H2v-3h10V43z M12,38H2v-3h10V38z M2,50h10v3H2V50z M14,50h10v3H14V50z M24,48H14       v-3h10V48z M2,30h10v3H2V30z M2,55h10v3H2V55z M24,58H14v-3h10V58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 5,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 10,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 3,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.e194d9da4203ad11e5fd3d039197b083.svg";
export { ForwardRef as ReactComponent };